import { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Table, Input, Button, DatePicker, message, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import analyticsApi from "../../../api/analytics-api";
import formatMoney from "../../../utils/formatMoney";

// Bảng số liệu theo TỪNG TÀI KHOẢN cookie (DailyStatAccounts). Giữ lại mức chi tiết
// mà email [V1-AUTO] từng có. Lọc theo tài khoản (cookie_platform) + khoảng ngày.

const CAMP_LABEL = { shopee: "Shopee", lazada: "Lazada", tiktok: "TikTok" };
const money = (v) => formatMoney.format(Number(v) || 0);
const num = (v) => (Number(v) || 0).toLocaleString("vi-VN");

function DashboardAccountDailyStats() {
    const [account, setAccount] = useState("");
    const [range, setRange] = useState(null); // [dayjs, dayjs] | null
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const params = { limit: 500 };
            if (account.trim()) params.account = account.trim();
            if (range && range[0] && range[1]) {
                params.from = range[0].format("YYYY-MM-DD");
                params.to = range[1].format("YYYY-MM-DD");
            }
            const res = await analyticsApi.getAccountDailyStats(params);
            setRows(res.data.data || []);
        } catch (err) {
            console.error("[AccountDailyStats] fetch error:", err);
            message.error("Không tải được số liệu theo tài khoản");
        } finally {
            setLoading(false);
        }
    }, [account, range]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const columns = useMemo(
        () => [
            { title: "Ngày", dataIndex: "stat_date", key: "stat_date", fixed: "left", width: 110 },
            { title: "Tài khoản", dataIndex: "cookie_platform", key: "cookie_platform", width: 180 },
            { title: "Sàn", dataIndex: "camp_id", key: "camp_id", render: (v) => CAMP_LABEL[v] || v || "—" },
            { title: "Đơn HT", dataIndex: "orders", key: "orders", align: "right", render: num },
            { title: "Chờ", dataIndex: "orders_pending", key: "orders_pending", align: "right", render: num },
            { title: "Hủy", dataIndex: "orders_cancelled", key: "orders_cancelled", align: "right", render: num },
            { title: "Buff", dataIndex: "buff_orders", key: "buff_orders", align: "right", render: num },
            { title: "HH sàn", dataIndex: "commission", key: "commission", align: "right", render: money },
            { title: "HH user", dataIndex: "user_commission", key: "user_commission", align: "right", render: money },
        ],
        []
    );

    return (
        <Card
            title="Số liệu theo tài khoản"
            className="shadow-sm"
            extra={
                <div className="flex items-center gap-2 flex-wrap">
                    <Input
                        allowClear
                        size="small"
                        style={{ width: 200 }}
                        placeholder="Lọc tài khoản (vd shopee_xxx)"
                        value={account}
                        onChange={(e) => setAccount(e.target.value)}
                        onPressEnter={fetchData}
                    />
                    <DatePicker.RangePicker
                        size="small"
                        value={range}
                        onChange={setRange}
                        placeholder={["Từ ngày", "đến"]}
                    />
                    <Tooltip title="Làm mới">
                        <Button
                            size="small"
                            icon={<FontAwesomeIcon icon={faArrowsRotate} />}
                            loading={loading}
                            onClick={fetchData}
                        />
                    </Tooltip>
                </div>
            }
        >
            <Table
                rowKey={(r) => `${r.stat_date}-${r.cookie_platform}`}
                columns={columns}
                dataSource={rows}
                loading={loading}
                size="small"
                scroll={{ x: "max-content" }}
                pagination={{ pageSize: 15, showSizeChanger: false }}
            />
        </Card>
    );
}

export default DashboardAccountDailyStats;
